import {DocumentAmendment} from "common/flowmaster/types/amendment";
import type {AmendmentErrorEntry} from "./amendment_group";

function truncate(text: string | undefined, max: number) {
  if (!text) {
    return undefined;
  }
  return text.length > max ? `${text.slice(0, max)}...` : text;
}

export default function buildAmendmentErrorEntry(
  amendment: DocumentAmendment,
  errorMessage: string,
  conversationId?: number,
  userPrompt?: string,
): AmendmentErrorEntry {
  return {
    error: errorMessage,
    issue_id: amendment.issue_id,
    clause_reference: amendment.clause_reference,
    action_type: amendment.action_type,
    deleted_text: truncate(amendment.deleted_text, 100),
    added_text: truncate(amendment.added_text, 100),
    before_text: truncate(amendment.before_text, 100),
    after_text: truncate(amendment.after_text, 100),
    conversationId,
    userPrompt,
  };
}
